import clsx from 'clsx';

function resolveOverflowPanelProps(_ref) {
  let {
    panelClassName,
    shouldUseOverflow
  } = _ref;
  const resolvedPanelClassName = clsx(panelClassName, shouldUseOverflow && 'ics-overlay-panel--overflow');
  return {
    resolvedPanelClassName: resolvedPanelClassName || undefined
  };
}

export { resolveOverflowPanelProps };
